/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SetUserDynamicPermissionsRequestPermissionsInner } from './SetUserDynamicPermissionsRequestPermissionsInner';
import {
    SetUserDynamicPermissionsRequestPermissionsInnerFromJSON,
    SetUserDynamicPermissionsRequestPermissionsInnerFromJSONTyped,
    SetUserDynamicPermissionsRequestPermissionsInnerToJSON,
    SetUserDynamicPermissionsRequestPermissionsInnerToJSONTyped,
} from './SetUserDynamicPermissionsRequestPermissionsInner';

/**
 * 
 * @export
 * @interface SetUserDynamicPermissionsRequest
 */
export interface SetUserDynamicPermissionsRequest {
    /**
     * 
     */
    permissions?: Array<SetUserDynamicPermissionsRequestPermissionsInner>;
}

/**
 * Check if a given object implements the SetUserDynamicPermissionsRequest interface.
 */
export function instanceOfSetUserDynamicPermissionsRequest(value: object): value is SetUserDynamicPermissionsRequest {
    return true;
}

export function SetUserDynamicPermissionsRequestFromJSON(json: any): SetUserDynamicPermissionsRequest {
    return SetUserDynamicPermissionsRequestFromJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetUserDynamicPermissionsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(SetUserDynamicPermissionsRequestPermissionsInnerFromJSON)),
    };
}

export function SetUserDynamicPermissionsRequestToJSON(json: any): SetUserDynamicPermissionsRequest {
    return SetUserDynamicPermissionsRequestToJSONTyped(json, false);
}

export function SetUserDynamicPermissionsRequestToJSONTyped(value?: SetUserDynamicPermissionsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(SetUserDynamicPermissionsRequestPermissionsInnerToJSON)),
    };
}

